<script>
	import { base } from '$app/paths';
	import { page } from '$app/stores';
	import links from './publicDocLinks.json';
</script>

<nav class="player-product-nav" aria-label="DCP Cine Player product pages">
	<a
		href={`${base}/dcp-cine-player/`}
		aria-current={$page.url.pathname === `${base}/dcp-cine-player/` ? 'page' : undefined}
		>Overview</a
	>
	{#each links.filter((link) => link.section === 'marketing' && link.slug !== 'index') as link}
		<a
			href={`${base}${link.path}`}
			aria-current={$page.url.pathname === `${base}${link.path}` ? 'page' : undefined}
			>{link.label}</a
		>
	{/each}
	<a
		href={`${base}/dcp-cine-player/manual/`}
		aria-current={$page.url.pathname.includes('/dcp-cine-player/manual/') ? 'page' : undefined}
		>User Manual</a
	>
	<a
		href={`${base}/dcp-cine-player/activation/`}
		aria-current={$page.url.pathname.includes('/dcp-cine-player/activation/') ? 'page' : undefined}
		>Get a FREE Licence</a
	>
</nav>

<style>
	.player-product-nav {
		display: flex;
		flex-wrap: wrap;
		gap: 4px 16px;
		padding: 12px 18px;
		background: #fff;
		border-bottom: 1px solid #cbd5dc;
	}
	a {
		color: #334550;
		font-size: 13px;
		font-weight: 600;
		padding: 5px 0;
		border-bottom: 2px solid transparent;
		text-decoration: none;
	}
	a:hover,
	a[aria-current='page'] {
		color: #12638d;
		border-bottom-color: #12638d;
	}
	a:focus-visible {
		outline: 2px solid #12638d;
		outline-offset: 3px;
	}
</style>
